<template lang="pug">
  b-collapse.box.membershipPackage.has-text-entered(v-if="membership" animation="slide" :open="open")
    template(#trigger="props")
      .is-flex.is-justify-content-space-between.is-align-items-center
        div.is-flex-grow-1.is-clickable(@click.stop="$emit('click')")
          p.title.is-5 
            span.icon.mr-2(v-if="membership.type === MEMBERSHIP_TYPES.PACKAGE")
              i.mdi.mdi-package-variant
            span.icon.mr-2(v-else)
              i.mdi.mdi-card-account-details-outline
            span {{membership.name}}
          p.subtitle.has-text-black.is-6.mb-1(v-t="'memberships.types.' + membership.type")    
          template(v-if="!props.open")
            p.has-text-black(v-if="membership.expire")
              span.has-text-weight-semibold(v-if="new Date(membership.expire) > new Date()")
                span(v-t="'misc.valid_til'")  
                |  
                date-view(:value="membership.expire" format="D MMM YYYY")
              span.has-text-danger.has-text-weight-semibold(v-else)
                span(v-t="'validity.expired'")
                |  
                date-view(:value="membership.expire" format="D MMM YYYY")
            p.has-text-black(v-else)
              span.has-text-primary(v-t="'misc.not_activated'")  
              |  -    
              span(v-t="'misc.valid_for'") 
              |  
              span {{validity.value}}  
              span  {{$t(`misc.${validity.unit}`)}}
        div.mr-2(v-if="membership.type === MEMBERSHIP_TYPES.MEMBERSHIP && !props.open")
          b(v-if="membership.remainingVisits !== undefined") {{membership.remainingVisits}} / 
          b(v-if="membership.capacity") {{membership.capacity}}
          b(v-else) ∞
        div
          span.icon.is-medium
            i.mdi.mdi-24px(:class="!props.open ? 'mdi-chevron-down' : 'mdi-chevron-up'")
    div.mt-4
      .has-text-black.mb-3.notification.p-2(v-if="membership.type === MEMBERSHIP_TYPES.PACKAGE")
        .list-item.px-0(v-for="{service, option, qty} in services")
          p 
            service-name-view.has-text-underline(:value="{service, option}")
            span  x  
            span.has-text-weight-bold(v-if="qty") {{qty}}
            span.has-text-weight-bold(v-else)  ∞ 
      div.is-flex.is-justify-content-space-between(v-else)
        div(style="flex: 1 1 0")
          p.heading.mb-0.has-text-grey {{ $t('memberships.capacity_label') }}
          p
            b(v-if="membership.remainingVisits !== undefined") {{membership.remainingVisits}} / 
            b(v-if="membership.capacity") {{membership.capacity}}
            b(v-else) ∞
        div(style="flex: 1 1 0")
          p.heading.mb-0.has-text-grey(v-t="'memberships.services_label'")
          .list-item.px-0(v-for="{service, option} in services.slice(0, 5)")
            p
              service-name-view.has-text-underline(:value="{service, option}")
          .list-item.px-0(v-if="services.length > 5")
            p.has-text-grey.is-size-7 ...{{services.length - 5}} more
      p.mb-3.has-text-black.is-size-7(v-if="membership.tc") {{membership.tc}}
      .is-flex.is-justify-content-space-between.has-border-top.pt-3.mt-3
        div
          p.has-text-black(v-if="membership.expire")
            span.has-text-weight-semibold(v-if="new Date(membership.expire) > new Date()")
              span(v-t="'misc.valid_til'")  
              |  
              date-view(:value="membership.expire" format="D MMM YYYY")
            span.has-text-danger.has-text-weight-semibold(v-else)
              span(v-t="'validity.expired'")
              |  
              date-view(:value="membership.expire" format="D MMM YYYY")

          p.has-text-black(v-else)
            span.has-text-primary(v-t="'misc.not_activated'")  
            |  -    
            span(v-t="'misc.valid_for'") 
            |  
            span {{validity.value}}  
            span  {{$t(`misc.${validity.unit}`)}}
          p
            span.has-text-grey.is-size-7
              invoice-view(:value="membership.sale" :invoice="membership.invoice")
              |  -  
              date-view(:value="membership.created" format="L LT")
        div
          p.is-size-5
            b
              currency-view(:value="membership.price")  
    

</template>
<script>
import {mapActions, mapState} from 'vuex'
import MEMBERSHIP_TYPES from '../../../constants/membershipTypes'

export default {
  name: 'CustomerMembershipView',
  props: {
    value: {type: String, required: true},
    open: {type: Boolean, default: false}
  },
  data() {
    return {
      MEMBERSHIP_TYPES
    }
  },
  computed: {
    ...mapState('memberships', ['membershipsMap']),
    ...mapState('membershipPackages', ['membershipPackagesMap']),
    membership() {
      return this.membershipsMap[this.value]
    },
    services() {
      if (this.membership.type === MEMBERSHIP_TYPES.PACKAGE) {
        return this.membership.remainingServices || this.membership.services
      }
      return this.membership.services
    },
    validity() {
      return this.membershipPackagesMap[this.membership.membershipPackage].validity
    }
  },
  async created() {
    await this.getMembershipById(this.value)
  },
  methods: {
    ...mapActions('memberships', ['getMembershipById'])
  }
}
</script>
<style scoped>
.membershipPackage {
  min-width: 300px;
  border-radius: 16px;
  /* background-color: #21d4fd;
  background-image: linear-gradient(19deg, #21d4fd 0%, #b721ff 100%); */
  /* background-image: radial-gradient(
    circle farthest-corner at 10% 20%,
    rgba(0, 152, 155, 1) 0.1%,
    rgba(0, 94, 120, 1) 94.2%
  ); */
  /* background: linear-gradient(to bottom, rgba(255, 255, 255, 0.15) 0%, rgba(0, 0, 0, 0.15) 100%),
    radial-gradient(at top center, rgba(255, 255, 255, 0.4) 0%, rgba(0, 0, 0, 0.4) 120%) #989898;
  background-blend-mode: multiply, multiply; */
  /* background-image: linear-gradient(-20deg, #2b5876 0%, #4e4376 100%); */
  border: 1px solid #d9d9d9;
  background-image: linear-gradient(-20deg, #f1f1f1 0%, #ffffff 100%);
}

.membershipPackage:hover .title {
  text-decoration: underline;
}
.membershipPackage hr {
  background-color: rgba(255, 255, 255, 0.5);
}
/* .membershipPackage p {
  color: white;
} */
</style>
